import { escapeHtml, formatElasticPriceHtml } from './helpers';

/**
 * Client-side product card renderer for Elastic listing results.
 * Canonical PHP markup lives in template-parts/cards/card-product.php (SSR).
 */
export const renderProductCardFromElastic = (product, options = {}) => {
    const placeholderImageUrl = String(options.placeholderImageUrl || '');
    const title = escapeHtml(product.post_title || '');
    const permalink = escapeHtml(product.permalink || '#');
    const placeholder = escapeHtml(placeholderImageUrl);
    const thumbnails = Array.isArray(product.thumbnails)
        ? product.thumbnails
        : [];
    const mainImage = thumbnails[0]?.url || '';
    const hoverImage = thumbnails[1]?.url || '';
    const priceHtml = formatElasticPriceHtml(product);
    const hasHoverImage = hoverImage !== '';
    const mainImageSrc = escapeHtml(mainImage || placeholder);

    const mainImageMarkup =
        mainImageSrc !== ''
            ? `<img class="bg-product-background rounded-medium w-full h-full object-cover" src="${mainImageSrc}" alt="${title}">`
            : '';

    const hoverImageMarkup = hasHoverImage
        ? `<img class="absolute left-0 top-0 w-full h-full object-cover rounded-medium opacity-0 group-[.-light]:opacity-100 transition-all" src="${escapeHtml(
              hoverImage
          )}" alt="${title}">`
        : '';

    const switchMarkup = hasHoverImage
        ? `<button js-switch-image type="button" class="bg-beige-500 block h-6 w-12 desktop:w-[56px] cursor-pointer rounded-full relative p-0.5"><div class="absolute left-0.5 top-1/2 h-5 -translate-y-1/2 w-5 bg-orange-500 origin-right rounded-full transition-all group-[.-light]:left-[calc(100%-14px)] group-[.-light]:w-3 group-[.-light]:rounded-bl-[100px] group-[.-light]:rounded-tl-[100px]"></div></button>`
        : '';

    return `<div><a class="block group aspect-square rounded-medium overflow-hidden relative bg-product-background rounded-medium" href="${permalink}" title="${title}">${mainImageMarkup}${hoverImageMarkup}<div class="absolute z-10 left-0 top-0 w-full h-full p-20 flex flex-col justify-between transition-all desktop:opacity-0 desktop:group-hover:opacity-100"><div class="flex justify-end">${switchMarkup}</div><div class="flex justify-between items-end text-text-primary group-[&.-light]:text-text-contrast"><div><p class="text-regular font-semibold">${title}</p><p class="text-tiny font-normal">${priceHtml}</p></div><div>warianty</div></div></div></a></div>`;
};

export const toggleProductCardImage = button => {
    const card = button.closest('.group');

    if (!card) {
        return false;
    }

    card.classList.toggle('-light');

    return true;
};

export const initProductCardSwitchers = (root = document) => {
    if (!root || typeof root.addEventListener !== 'function') {
        return;
    }

    root.addEventListener('click', event => {
        const button = event.target.closest('[js-switch-image]');

        if (!button || !root.contains(button)) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        toggleProductCardImage(button);
    });
};
